// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"0917efb8","8":"cdb915fd","122":"dfea84c8","442":"3ec8fcd8","488":"032ad3b8","602":"748c5512","760":"7afd80a6","787":"2f3f3b6b","825":"13fda2d7","828":"f3264339","873":"5e849f8f"}[chunkId] + ".chunk.js";
};